import controller from './pdf-viewer.controller';
import templateBase from './templates/pdf-viewer-base.view.html';

let PdfViewerComponent = {
    template:changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};


changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    //let response = SessionService.get('components');

    /*if (response.BY_FAVORITES.component == 'template_t1') {
        return templateT1;
    } else {*/
    return templateBase;
    //}
}

export default PdfViewerComponent;



/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/shared/components/pdf-viewer/pdf-viewer.component.js
 **/